import { useState, useEffect } from "react";
import { usePostHog } from "posthog-js/react";

export const useFeatureFlag = (flagKey) => {
  const posthog = usePostHog();
  const [value, setValue] = useState(() => posthog?.isFeatureEnabled(flagKey));

  useEffect(() => {
    if (!posthog) return;
    return posthog.onFeatureFlags(() => {
      setValue(posthog.isFeatureEnabled(flagKey));
    });
  }, [posthog, flagKey]);

  return value;
};

export const useFeatureFlagVariant = (flagKey) => {
  const posthog = usePostHog();
  const [value, setValue] = useState(() => posthog?.getFeatureFlag(flagKey) ?? null);

  useEffect(() => {
    if (!posthog) return;
    return posthog.onFeatureFlags(() => {
      setValue((prev) => prev ?? posthog.getFeatureFlag(flagKey));
    });
  }, [posthog, flagKey]);

  return value;
};
